export default {
  id: {
    minify: process.env.NODE_ENV === 'production'
  }
}
